import { motion } from 'framer-motion';
import { PageTransition, FadeIn } from '../components/PageTransition';
import { BackButton } from '../components/BackButton';

// Organizational Structure Data
const orgStructure = {
  topLeadership: [
    {
      name: 'Tanvi Somaiya',
      role: 'Founder'
    },
    {
      name: 'Harsh Jayesh Somaiya',
      role: 'Co-Director'
    }
  ],
  
  // Department 2 - Sales
  sales: {
    head: { name: 'ROHITKANT PRASAD', role: 'Head Brand (Sales)' },
    channels: ['Online', 'Offline'],
    retailOps: {
      head: { name: 'Kartik Ahluwalia', role: 'General Manager – Retail Operations' },
      verticals: {
        // Vertical 1 - EBO
        ebo: {
          head: { name: 'Chetan Sahgal', role: 'Senior Manager – Retail Operations' },
          team: [
            { name: 'Anandakrishnan B', role: 'Assistant Manager – Cluster Manager (South)' },
            { name: 'Nandan Pinnamaneni', role: 'Assistant Manager – Cluster Manager (South)' },
            { name: 'Bappa Maji', role: 'Assistant Manager – Cluster Manager' }
          ]
        },
        // Vertical 2 - SIS
        sis: {
          head: { name: 'Syed Saqeeb', role: 'Senior Manager – Operations & Strategy' },
          team: [
            { name: 'Sourabh Bose', role: 'Assistant Manager (East)' },
            { name: 'Pawan Mishra', role: 'Assistant Manager – Cluster Manager (North)' },
            { name: 'Rajmohan Musapet', role: 'Assistant Manager – Cluster Manager (South)' },
            { name: 'Jagadish G', role: 'Assistant Manager – Cluster Manager' },
            { name: "Austin Merwyn D'Souza", role: 'Assistant Manager – Cluster Manager' }
          ]
        },
        // Vertical 3 - Retail Planning
        retailPlanning: {
          head: { name: 'Jagadishwaran GK', role: 'Senior Manager – Retail Planner' },
          team: [
            { name: 'Deepak K', role: 'Manager – Retail Planner' },
            { name: 'Nidhi Maithani', role: 'Assistant Manager – Offline Merchandising' },
            { name: 'Pooja', role: 'Assistant Manager – Retail Planning' }
          ]
        },
        // Vertical 4 - National Sales (MBO)
        nationalSales: {
          head: { name: 'Vikas Mehra', role: 'DGM – National Sales' },
          team: [
            { name: 'Vijaykumar G Prajapati', role: 'Manager – Sales West' },
            { name: 'Amit Sinha', role: 'Manager – Sales East' }
          ]
        }
      }
    }
  },
  
  // Department 3 - VM & Retail Experience
  vmRetail: {
    head: { name: 'Anshul Khandelwal', role: 'DGM – Visual Merchandising & Training' },
    branches: {
      // Branch 1 - Training & Development
      training: {
        head: { name: 'Priyanka', role: 'Training & Development Lead' }
      },
      // Branch 2 - VM Styling
      vmStyling: {
        head: { name: 'Pranjita Bisht', role: 'Manager – VM & Styling' },
        areaTeams: [
          { name: 'Rohit', role: 'North' },
          { name: 'Dipak Biswal', role: 'West Bengal & North East' },
          { name: 'Dinesh', role: 'Mumbai Suburb' },
          { name: 'Sandeep', role: 'Karnataka & Kerala' },
          { name: 'Rashid Khan', role: 'NCR' },
          { name: 'Praveen Panwar', role: 'Madhya Pradesh & Chhattisgarh' },
          { name: 'Harsha Rudroju', role: 'Rest of Maharashtra & Goa' },
          { name: 'Pravesh Kumar Pandey', role: 'Tamil Nadu' },
          { name: 'Smita Kumari', role: 'Gujarat' },
          { name: 'Mansi Goswami', role: 'Uttar Pradesh & Uttarakhand' },
          { name: 'Kavita', role: 'Mumbai' },
          { name: 'Abhishek', role: 'Hyderabad' }
        ]
      },
      // Branch 3 - VM Creative
      vmCreative: {
        head: { name: 'Ankit Gara', role: 'VM Creative' }
      },
      // Branch 4 - VM Operations & Vendor Management
      vmOperations: {
        head: { name: 'Sulekha Y', role: 'Manager – VM Operations & Vendor Management' },
        report: { name: 'Sitara Vinod', role: 'VM Operations & Vendor Management' }
      }
    }
  },
  
  // Department 4 - Finance
  finance: {
    head: { name: 'Saurabh Verma', role: 'General Manager – Finance Controller' },
    report: { name: 'Anil Kumar K', role: 'Senior Manager – Finance' }
  },
  
  // Department 5 - Design
  design: {
    head: { name: 'Nikhil', role: 'Senior Manager – Design' }
  },
  
  // Department 6 - Marketing
  marketing: {
    head: { name: 'Shekar', role: 'Brand Marketing' },
    team: [
      { name: 'Diksha Srivastava', role: 'Manager – Brand Marketing' },
      { name: 'Rohan Bharadwaj', role: 'Executive – Video Editor' },
      { name: 'Divyanee Soni', role: 'Senior Executive – Graphic Designer' }
    ]
  },
  
  // Department 7 - Human Resources
  hr: {
    head: { name: 'Kriti', role: 'Senior Manager – Human Resources' },
    chain: [
      { name: 'Akshara', role: 'Senior Executive – Human Resources' },
      { name: 'Aman', role: 'Senior Executive – Retail Human Resources' }
    ]
  }
};

// Escalation Categories
const escalationCategories = [
  {
    id: 1,
    category: 'Operations',
    subtitle: 'Ops Related Issues',
    contact: 'Cluster Managers',
    cc: 'Chetan Sahgal, Kartik Ahluwalia'
  },
  {
    id: 2,
    category: 'Project',
    subtitle: 'Project Related Issues',
    contact: 'Makarand Deshpande',
    cc: 'Cluster Managers, Chetan Sahgal'
  },
  {
    id: 3,
    category: 'Marketing',
    subtitle: 'Marketing Related Matters',
    contact: 'Shekhar Swain',
    cc: 'Cluster Managers, Chetan Sahgal'
  },
  {
    id: 4,
    category: 'VM Issues',
    subtitle: 'Visual Merchandising – Works & Issues',
    contact: 'Cluster VM Teams (Rohit, Dinesh, Abhishek)',
    cc: 'Anshul Khandelwal, Cluster Managers, Chetan Sahgal'
  },
  {
    id: 5,
    category: 'Training & SOP',
    subtitle: 'Training & SOP Related Matters',
    contact: 'Priyanka Jayprakash',
    cc: 'Cluster Managers, Chetan Sahgal'
  },
  {
    id: 6,
    category: 'Stock',
    subtitle: 'Stock Related Issues',
    contact: 'Pooja (Retail Planning)',
    cc: 'Jagadishwaran GK, Girish, Niranjan, Cluster Managers, Chetan Sahgal'
  },
  {
    id: 7,
    category: 'ERP',
    subtitle: 'ERP Related Issues',
    contact: 'Satyakam Chavan (Senior Manager ERP)',
    cc: 'Cluster Managers, Chetan Sahgal'
  },
  {
    id: 8,
    category: 'Finance',
    subtitle: 'Finance Related Issues',
    contact: 'Divas',
    cc: 'Cluster Managers, Chetan Sahgal'
  },
  {
    id: 9,
    category: 'IT',
    subtitle: 'IT Related Issues',
    contact: 'Gopi',
    cc: 'Cluster Managers'
  }
];

// Node Component with soft shadow and rounded corners
const OrgNode = ({ name, role, isHighlight = false, size = 'normal' }) => {
  const sizeClasses = {
    large: 'px-8 py-5 min-w-[240px]',
    normal: 'px-6 py-4 min-w-[200px]',
    small: 'px-4 py-3 min-w-[160px]'
  };
  
  return (
    <motion.div
      className={`bg-white rounded-lg shadow-md ${sizeClasses[size]} text-center ${
        isHighlight ? 'border-2 border-[#D32F2F]' : 'border border-[rgba(26,26,26,0.08)]'
      }`}
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      viewport={{ once: true }}
      whileHover={{ y: -2, shadow: 'lg' }}
    >
      <h4 className={`font-semibold text-[#1A1A1A] ${size === 'large' ? 'text-sm' : 'text-xs'} uppercase tracking-wide`}>
        {name}
      </h4>
      <p className={`text-[#1A1A1A]/60 mt-1 ${size === 'large' ? 'text-xs' : 'text-[10px]'}`}>
        {role}
      </p>
    </motion.div>
  );
};

// Connector Line
const Connector = ({ direction = 'vertical', length = 'normal' }) => {
  const lengths = { short: 'h-4', normal: 'h-8', long: 'h-12' };
  
  if (direction === 'vertical') {
    return (
      <div className={`w-[2px] ${lengths[length]} bg-[#1A1A1A]/20 mx-auto`} />
    );
  }
  return <div className="h-[2px] flex-1 bg-[#1A1A1A]/20" />;
};

// Branch Label
const BranchLabel = ({ label }) => (
  <div className="text-[10px] uppercase tracking-[0.15em] text-[#D32F2F] font-semibold mb-3 text-center">
    {label}
  </div>
);

// Escalation Card for Radial Layout
const EscalationCard = ({ item, index }) => {
  const angle = (index * 40) - 90;
  const radius = 280;
  const x = Math.cos((angle * Math.PI) / 180) * radius;
  const y = Math.sin((angle * Math.PI) / 180) * radius;
  
  return (
    <motion.div
      className="absolute bg-white rounded-lg shadow-md p-4 w-[200px] border-l-4 border-[#D32F2F]"
      style={{
        left: `calc(50% + ${x}px - 100px)`,
        top: `calc(50% + ${y}px - 50px)`,
      }}
      initial={{ opacity: 0, scale: 0.8 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
      viewport={{ once: true }}
      whileHover={{ scale: 1.02 }}
    >
      <div className="text-[10px] text-[#D32F2F] font-bold uppercase tracking-wide mb-1">
        {item.id}. {item.category}
      </div>
      <div className="text-[9px] text-[#1A1A1A]/50 mb-2">{item.subtitle}</div>
      <div className="text-[10px] text-[#1A1A1A]">
        <span className="text-[#1A1A1A]/50">To: </span>
        <span className="font-medium">{item.contact}</span>
      </div>
      <div className="text-[9px] text-[#1A1A1A]/50 mt-1">
        <span>CC: </span>{item.cc}
      </div>
    </motion.div>
  );
};

// Connector Line to Escalation Card (for radial)
const RadialConnector = ({ index }) => {
  const angle = (index * 40) - 90;
  const innerRadius = 60;
  const outerRadius = 180;
  
  const x1 = Math.cos((angle * Math.PI) / 180) * innerRadius;
  const y1 = Math.sin((angle * Math.PI) / 180) * innerRadius;
  const x2 = Math.cos((angle * Math.PI) / 180) * outerRadius;
  const y2 = Math.sin((angle * Math.PI) / 180) * outerRadius;
  
  return (
    <line
      x1={x1}
      y1={y1}
      x2={x2}
      y2={y2}
      stroke="#1A1A1A"
      strokeWidth="1.5"
      strokeOpacity="0.15"
    />
  );
};

// Small Team Card
const TeamCard = ({ name, role, delay = 0 }) => (
  <motion.div
    className="bg-white rounded shadow-sm px-3 py-2 text-center border border-[rgba(26,26,26,0.05)]"
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    transition={{ delay }}
    viewport={{ once: true }}
  >
    <div className="text-[10px] font-medium text-[#1A1A1A]">{name}</div>
    <div className="text-[8px] text-[#1A1A1A]/50">{role}</div>
  </motion.div>
);

// Arrow Team Card
const ArrowTeamCard = ({ name, role, delay = 0, indent = false }) => (
  <motion.div
    className={`bg-white rounded shadow-sm px-4 py-3 text-center border border-[rgba(26,26,26,0.05)] flex items-center gap-2 ${indent ? 'ml-6' : ''}`}
    initial={{ opacity: 0, x: -10 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ delay }}
    viewport={{ once: true }}
  >
    <span className={`text-[#D32F2F] text-xs ${indent ? 'opacity-60' : ''}`}>↳</span>
    <div className="text-left">
      <div className={`font-medium text-[#1A1A1A] ${indent ? 'text-[9px]' : 'text-[10px]'}`}>{name}</div>
      <div className={`text-[#1A1A1A]/50 ${indent ? 'text-[7px]' : 'text-[8px]'}`}>{role}</div>
    </div>
  </motion.div>
);

// Area Team Card (colored background)
const AreaTeamCard = ({ name, role, delay = 0 }) => (
  <motion.div
    className="bg-[#D32F2F]/5 border border-[#D32F2F]/20 rounded px-3 py-2 text-center"
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    transition={{ delay }}
    viewport={{ once: true }}
  >
    <div className="text-[9px] font-medium text-[#1A1A1A]">{name}</div>
    <div className="text-[7px] text-[#1A1A1A]/60 leading-tight">{role}</div>
  </motion.div>
);

const EscalationMatrixPage = () => {
  return (
    <PageTransition className="min-h-screen bg-[#F8F6F2] py-24 px-6">
      <div className="grain-overlay" />
      <BackButton to="/what" label="Back" />

      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-xs uppercase tracking-[0.3em] text-[#1A1A1A]/60 mb-4">
            Training Module
          </h2>
          <h1 className="text-4xl md:text-5xl font-light tracking-tight text-[#1A1A1A]">
            Escalation Matrix
          </h1>
        </motion.div>

        {/* ============================================ */}
        {/* FLOW CHART 1 - ORGANIZATIONAL STRUCTURE */}
        {/* ============================================ */}
        <FadeIn delay={0.2}>
          <div className="mb-32">
            <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-center text-[#1A1A1A]/60 mb-16">
              Flow Chart 1 – Organizational Structure
            </h3>
            
            <div className="flex flex-col items-center">
              {/* Level 1 - Top Leadership (Dual) */}
              <div className="flex items-center justify-center gap-8">
                {orgStructure.topLeadership.map((leader, idx) => (
                  <OrgNode 
                    key={idx}
                    name={leader.name} 
                    role={leader.role}
                    isHighlight
                    size="large"
                  />
                ))}
              </div>
              <Connector length="long" />

              {/* Separator */}
              <div className="w-full max-w-5xl h-px bg-[#1A1A1A]/10 my-8" />

              {/* ========== DEPARTMENT 2: SALES ========== */}
              <div className="flex flex-col items-center mb-12 w-full">
                <BranchLabel label="Sales" />
                <OrgNode 
                  name={orgStructure.sales.head.name}
                  role={orgStructure.sales.head.role}
                  isHighlight
                  size="small"
                />
                <Connector length="short" />
                
                {/* Online / Offline Split */}
                <div className="flex gap-6 mb-4">
                  <div className="bg-[#F8F6F2] border border-[rgba(26,26,26,0.1)] rounded px-4 py-2 text-[10px] uppercase tracking-wide text-[#1A1A1A]/70">
                    Online
                  </div>
                  <div className="bg-[#F8F6F2] border border-[rgba(26,26,26,0.1)] rounded px-4 py-2 text-[10px] uppercase tracking-wide text-[#1A1A1A]/70">
                    Offline
                  </div>
                </div>
                <Connector length="short" />
                
                {/* Kartik - GM Retail Ops */}
                <OrgNode 
                  name={orgStructure.sales.retailOps.head.name}
                  role={orgStructure.sales.retailOps.head.role}
                  isHighlight
                  size="small"
                />
                <Connector length="normal" />

                {/* Four Verticals Under Kartik */}
                <div className="flex flex-wrap items-start justify-center gap-8 w-full max-w-6xl">
                  
                  {/* Vertical 1 - EBO */}
                  <div className="flex flex-col items-center min-w-[200px]">
                    <BranchLabel label="1. EBO (Exclusive Brand Outlet)" />
                    <OrgNode 
                      name={orgStructure.sales.retailOps.verticals.ebo.head.name}
                      role={orgStructure.sales.retailOps.verticals.ebo.head.role}
                      isHighlight
                      size="small"
                    />
                    <Connector length="short" />
                    <div className="flex flex-col gap-2">
                      {orgStructure.sales.retailOps.verticals.ebo.team.map((member, idx) => (
                        <ArrowTeamCard key={idx} name={member.name} role={member.role} delay={idx * 0.1} />
                      ))}
                    </div>
                  </div>

                  {/* Vertical 2 - SIS */}
                  <div className="flex flex-col items-center min-w-[200px]">
                    <BranchLabel label="2. SIS (Shop-in-Shop)" />
                    <OrgNode 
                      name={orgStructure.sales.retailOps.verticals.sis.head.name}
                      role={orgStructure.sales.retailOps.verticals.sis.head.role}
                      isHighlight
                      size="small"
                    />
                    <Connector length="short" />
                    <div className="flex flex-col gap-2">
                      {orgStructure.sales.retailOps.verticals.sis.team.map((member, idx) => (
                        <ArrowTeamCard key={idx} name={member.name} role={member.role} delay={idx * 0.1} />
                      ))}
                    </div>
                  </div>

                  {/* Vertical 3 - Retail Planning */}
                  <div className="flex flex-col items-center min-w-[200px]">
                    <BranchLabel label="3. Retail Planning" />
                    <OrgNode 
                      name={orgStructure.sales.retailOps.verticals.retailPlanning.head.name}
                      role={orgStructure.sales.retailOps.verticals.retailPlanning.head.role}
                      isHighlight
                      size="small"
                    />
                    <Connector length="short" />
                    <div className="flex flex-col gap-2">
                      {orgStructure.sales.retailOps.verticals.retailPlanning.team.map((member, idx) => (
                        <ArrowTeamCard key={idx} name={member.name} role={member.role} delay={idx * 0.1} />
                      ))}
                    </div>
                  </div>

                  {/* Vertical 4 - National Sales (MBO) */}
                  <div className="flex flex-col items-center min-w-[200px]">
                    <BranchLabel label="4. National Sales (MBO)" />
                    <OrgNode 
                      name={orgStructure.sales.retailOps.verticals.nationalSales.head.name}
                      role={orgStructure.sales.retailOps.verticals.nationalSales.head.role}
                      isHighlight
                      size="small"
                    />
                    <Connector length="short" />
                    <div className="flex flex-col gap-2">
                      {orgStructure.sales.retailOps.verticals.nationalSales.team.map((member, idx) => (
                        <ArrowTeamCard key={idx} name={member.name} role={member.role} delay={idx * 0.1} />
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Separator */}
              <div className="w-full max-w-5xl h-px bg-[#1A1A1A]/10 my-12" />

              {/* ========== DEPARTMENT 3: VM & RETAIL EXPERIENCE ========== */}
              <div className="flex flex-col items-center mb-12 w-full">
                <BranchLabel label="VM & Retail Experience" />
                <OrgNode 
                  name={orgStructure.vmRetail.head.name}
                  role={orgStructure.vmRetail.head.role}
                  isHighlight
                  size="small"
                />
                <Connector length="normal" />

                {/* Four VM Branches */}
                <div className="flex flex-wrap items-start justify-center gap-8 w-full max-w-6xl">
                  
                  {/* Branch 1 - Training & Development */}
                  <div className="flex flex-col items-center min-w-[200px]">
                    <BranchLabel label="Training & Development" />
                    <TeamCard 
                      name={orgStructure.vmRetail.branches.training.head.name}
                      role={orgStructure.vmRetail.branches.training.head.role}
                    />
                  </div>

                  {/* Branch 2 - VM Styling */}
                  <div className="flex flex-col items-center min-w-[200px]">
                    <BranchLabel label="VM Styling" />
                    <TeamCard 
                      name={orgStructure.vmRetail.branches.vmStyling.head.name}
                      role={orgStructure.vmRetail.branches.vmStyling.head.role}
                    />
                    <Connector length="short" />
                    <div className="text-[9px] uppercase tracking-wide text-[#D32F2F]/80 font-medium mb-2">Area Teams</div>
                    <div className="grid grid-cols-2 gap-2">
                      {orgStructure.vmRetail.branches.vmStyling.areaTeams.map((member, idx) => (
                        <AreaTeamCard key={idx} name={member.name} role={member.role} delay={idx * 0.05} />
                      ))}
                    </div>
                  </div>

                  {/* Branch 3 - VM Creative */}
                  <div className="flex flex-col items-center min-w-[160px]">
                    <BranchLabel label="VM Creative" />
                    <TeamCard 
                      name={orgStructure.vmRetail.branches.vmCreative.head.name}
                      role={orgStructure.vmRetail.branches.vmCreative.head.role}
                    />
                  </div>

                  {/* Branch 4 - VM Operations & Vendor Management */}
                  <div className="flex flex-col items-center min-w-[200px]">
                    <BranchLabel label="VM Operations & Vendor Mgmt" />
                    <TeamCard 
                      name={orgStructure.vmRetail.branches.vmOperations.head.name}
                      role={orgStructure.vmRetail.branches.vmOperations.head.role}
                    />
                    <Connector length="short" />
                    <TeamCard 
                      name={orgStructure.vmRetail.branches.vmOperations.report.name}
                      role={orgStructure.vmRetail.branches.vmOperations.report.role}
                    />
                  </div>
                </div>
              </div>

              {/* Separator */}
              <div className="w-full max-w-5xl h-px bg-[#1A1A1A]/10 my-12" />

              {/* ========== REMAINING DEPARTMENTS ROW ========== */}
              <div className="flex flex-wrap items-start justify-center gap-12 w-full max-w-6xl">
                
                {/* Department 4 - Finance */}
                <div className="flex flex-col items-center">
                  <BranchLabel label="Finance" />
                  <OrgNode 
                    name={orgStructure.finance.head.name}
                    role={orgStructure.finance.head.role}
                    size="small"
                  />
                  <Connector length="short" />
                  <ArrowTeamCard 
                    name={orgStructure.finance.report.name}
                    role={orgStructure.finance.report.role}
                  />
                </div>

                {/* Department 5 - Design */}
                <div className="flex flex-col items-center">
                  <BranchLabel label="Design" />
                  <OrgNode 
                    name={orgStructure.design.head.name}
                    role={orgStructure.design.head.role}
                    size="small"
                  />
                </div>

                {/* Department 6 - Marketing */}
                <div className="flex flex-col items-center">
                  <BranchLabel label="Marketing" />
                  <OrgNode 
                    name={orgStructure.marketing.head.name}
                    role={orgStructure.marketing.head.role}
                    size="small"
                  />
                  <Connector length="short" />
                  <div className="flex flex-col gap-2">
                    {orgStructure.marketing.team.map((member, idx) => (
                      <ArrowTeamCard key={idx} name={member.name} role={member.role} delay={idx * 0.1} />
                    ))}
                  </div>
                </div>

                {/* Department 7 - Human Resources */}
                <div className="flex flex-col items-center">
                  <BranchLabel label="Human Resources" />
                  <OrgNode 
                    name={orgStructure.hr.head.name}
                    role={orgStructure.hr.head.role}
                    size="small"
                  />
                  <Connector length="short" />
                  <div className="flex flex-col gap-2">
                    {orgStructure.hr.chain.map((member, idx) => (
                      <ArrowTeamCard 
                        key={idx} 
                        name={member.name} 
                        role={member.role} 
                        delay={idx * 0.1}
                        indent={idx > 0}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* ============================================ */}
        {/* FLOW CHART 2 - ESCALATION MATRIX OPERATIONS */}
        {/* ============================================ */}
        <FadeIn delay={0.4}>
          <div className="border-t border-[rgba(26,26,26,0.1)] pt-20">
            <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-center text-[#1A1A1A]/60 mb-4">
              Flow Chart 2 – Escalation Matrix – Operations
            </h3>
            <p className="text-center text-sm text-[#1A1A1A]/50 mb-16">
              Decision-based flow: Identify issue → Select category → Contact appropriate team
            </p>

            {/* Radial Layout Container */}
            <div className="relative h-[700px] w-full max-w-[800px] mx-auto">
              {/* Center Circle with SVG connectors */}
              <svg 
                className="absolute inset-0 w-full h-full" 
                viewBox="-400 -350 800 700"
                preserveAspectRatio="xMidYMid meet"
              >
                {/* Radial connector lines */}
                {escalationCategories.map((_, index) => (
                  <RadialConnector key={index} index={index} />
                ))}
              </svg>

              {/* Center Node */}
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
                <motion.div
                  className="bg-[#1A1A1A] text-white rounded-full w-32 h-32 flex items-center justify-center text-center shadow-lg"
                  initial={{ scale: 0 }}
                  whileInView={{ scale: 1 }}
                  transition={{ duration: 0.5, type: 'spring' }}
                >
                  <div>
                    <div className="text-[10px] uppercase tracking-wider opacity-70">Issue</div>
                    <div className="text-xs font-semibold uppercase tracking-wide">Identified</div>
                  </div>
                </motion.div>
                
                {/* Select Category Ring */}
                <motion.div
                  className="absolute -inset-8 border-2 border-dashed border-[#D32F2F]/40 rounded-full"
                  initial={{ scale: 0, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                />
                <motion.div
                  className="absolute -bottom-14 left-1/2 -translate-x-1/2 bg-[#D32F2F] text-white px-4 py-2 rounded text-[10px] uppercase tracking-wider font-semibold whitespace-nowrap shadow-md"
                  initial={{ opacity: 0, y: -10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5 }}
                >
                  Select Issue Category
                </motion.div>
              </div>

              {/* Escalation Cards in Radial Layout */}
              {escalationCategories.map((item, index) => (
                <EscalationCard key={item.id} item={item} index={index} />
              ))}
            </div>

            {/* Alternative Grid View for Mobile */}
            <div className="mt-16 md:hidden">
              <div className="grid grid-cols-1 gap-4">
                {escalationCategories.map((item) => (
                  <motion.div
                    key={item.id}
                    className="bg-white rounded-lg shadow-md p-5 border-l-4 border-[#D32F2F]"
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4 }}
                  >
                    <div className="text-xs text-[#D32F2F] font-bold uppercase tracking-wide mb-1">
                      {item.id}. {item.category}
                    </div>
                    <div className="text-[11px] text-[#1A1A1A]/50 mb-3">{item.subtitle}</div>
                    <div className="text-xs text-[#1A1A1A]">
                      <span className="text-[#1A1A1A]/50">To: </span>
                      <span className="font-medium">{item.contact}</span>
                    </div>
                    <div className="text-[10px] text-[#1A1A1A]/50 mt-1">
                      <span>CC: </span>{item.cc}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </PageTransition>
  );
};

export default EscalationMatrixPage;
